import { render, staticRenderFns } from "./groupChatContent.vue?vue&type=template&id=125688cb&scoped=true&"
import script from "./groupChatContent.vue?vue&type=script&lang=js&"
export * from "./groupChatContent.vue?vue&type=script&lang=js&"
import style0 from "./groupChatContent.vue?vue&type=style&index=0&id=125688cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125688cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125688cb')) {
      api.createRecord('125688cb', component.options)
    } else {
      api.reload('125688cb', component.options)
    }
    module.hot.accept("./groupChatContent.vue?vue&type=template&id=125688cb&scoped=true&", function () {
      api.rerender('125688cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/newGroupChat/groupChatContent.vue"
export default component.exports